export const CHANGE_BRAND = "CHANGE_BRAND"
export const CHANGE_CITY = "CHANGE_CITY"

export interface AnalysisBrandAction<T extends object = {}> {
  type: typeof CHANGE_BRAND
  value: T
}

export interface AnalysisCityAction<T extends object = {}> {
  type: typeof CHANGE_CITY
  value: T
}

export type AnalysisAction = AnalysisBrandAction | AnalysisCityAction
